module.exports = __webpack_public_path__ + "static/media/mail.c05e6bf8.svg";